<template>
  <section
    component="card"
    class="rounded"
    :class="[
      padding,
      classes !== '' ? classes:[getBg(), getShadow()]
    ]"
  >
    <slot></slot>
  </section>
</template>


<script>

export default {
  name: 'Card',
  props:{
    padding:{
      type: String,
      default: 'p-3'
    },
    bg:{
      type: [String, Array, Boolean],
      default: 'bg-white dark:bg-slate-900'
    },
    shadow:{
      type: [String, Array, Boolean],
      default: 'shadow-md'
    },
    classes:{
      type: [String, Array, Object],
      default: ''
    }
  },
  methods: {
    getDefault(val){
      if(typeof this[val] == "boolean") return this[val] ? this.$options.props[val].default : '';
      return this[val];
    },
    getBg(){
      return this.getDefault('bg');
    },
    getShadow(){
      return this.getDefault('shadow');
    },
  }
}

</script>
